// Полоса «вы работаете от имени…».
//
// Режим, в котором администратор сидит в чужом аккаунте, снаружи неотличим от
// обычной работы: то же меню, те же поездки, та же кнопка сохранения. Отличие
// в последствиях — правки уходят живому человеку, — поэтому напоминание висит
// поверх всех экранов и не закрывается: спрятать его значило бы забыть, чьи
// данные правишь.
//
// Полоса зафиксирована сверху, а место под неё освобождает переменная
// --imp-bar (см. styles/global.css): раскладка планировщика считает высоту от
// вьюпорта, и просто вставить блок в поток нельзя — она вылезла бы за экран.
import { useEffect, type ReactElement } from 'react';
import { useT } from '../i18n';
import { useAuth } from './AuthProvider';
import { stopImpersonation } from './api';
import styles from './ImpersonationBar.module.css';

/** Высота полосы: столько же занимает отступ страницы под неё. */
const BAR_HEIGHT = '2.25rem';

export function ImpersonationBar(): ReactElement | null {
  const t = useT();
  const { user, impersonator } = useAuth();
  const active = Boolean(user && impersonator);

  useEffect(() => {
    const root = document.documentElement;
    if (!active) return undefined;
    root.style.setProperty('--imp-bar', BAR_HEIGHT);
    return () => {
      root.style.removeProperty('--imp-bar');
    };
  }, [active]);

  if (!user || !impersonator) return null;

  async function handleStop(): Promise<void> {
    await stopImpersonation();
    // Полная перезагрузка, а не refresh(): вместе с сессией меняются и
    // поездки, и состояние планировщика в памяти — собрать их заново с нуля
    // надёжнее, чем перетряхивать все провайдеры на живом экране.
    window.location.assign('/admin?tab=trips');
  }

  return (
    <div className={styles.bar} role="status">
      <span className={styles.text}>
        {t('impersonate.bar', { email: user.email, admin: impersonator.email })}
      </span>
      <button type="button" className={styles.action} onClick={() => void handleStop()}>
        {t('impersonate.stop')}
      </button>
    </div>
  );
}
